import { Link } from "react-router-dom";
import { Play, BookOpen, Check } from "lucide-react";
import { NARRATORS, chapterLabel } from "../data/book";
import { useLang } from "../i18n";

const StoryCard = ({ story, progress }) => {
  const { lang, t } = useLang();
  const nar = NARRATORS[story.narrator];
  const p = progress?.[String(story.id)];
  return (
    <div
      data-testid={`chapter-card-${story.num}`}
      className="group relative rounded-xl border border-white/10 bg-card p-6 transition-all duration-500 hover:-translate-y-1.5 hover:bg-cardhover hover:border-ember/50 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        style={{ background: `radial-gradient(ellipse 90% 60% at 50% 120%, ${nar.dim}, transparent 70%)` }}
      />
      <div className="relative flex items-start justify-between mb-6">
        <span className="font-display font-extrabold text-5xl leading-none text-white/10 group-hover:text-ember/60 transition-colors duration-500">
          {story.num}
        </span>
        <div className="flex items-center gap-2">
          {p?.read && (
            <span className="font-mono2 text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full border text-gold border-gold/50 bg-gold/10 flex items-center gap-1" data-testid={`card-read-badge-${story.num}`}>
              <Check className="w-3 h-3" /> {t("read_badge")}
            </span>
          )}
          {!p?.read && p?.percent > 0 && (
            <span className="font-mono2 text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full border text-ember border-ember/50 bg-ember/10" data-testid={`card-progress-badge-${story.num}`}>
              {p.percent}%
            </span>
          )}
          <span
            className="font-mono2 text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full border"
            style={{ color: nar.color, borderColor: `${nar.color}55`, background: nar.dim }}
          >
            {nar[lang] ?? nar.it}
          </span>
        </div>
      </div>
      <Link to={`/storia/${story.id}?v=read`} className="relative block" data-testid={`card-read-link-${story.num}`}>
        <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-mute mb-2">
          {chapterLabel(story, lang)} · {t("chapter_word")} p.{story.page}
        </p>
        <p className="text-sm text-mist leading-relaxed clamp-3 mb-5">
          {story[lang] ?? story.it}
        </p>
      </Link>
      <div className="relative flex items-center gap-3">
        <Link
          to={`/storia/${story.id}?v=watch`}
          data-testid={`card-watch-${story.num}`}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-ember/50 py-2.5 text-[11px] font-mono2 tracking-[0.2em] uppercase text-ember hover:bg-ember hover:text-black transition-colors"
        >
          <Play className="w-3.5 h-3.5" /> {t("card_watch")}
        </Link>
        <Link
          to={`/storia/${story.id}?v=read`}
          data-testid={`card-read-${story.num}`}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-white/15 py-2.5 text-[11px] font-mono2 tracking-[0.2em] uppercase text-mist hover:border-gold hover:text-gold transition-colors"
        >
          <BookOpen className="w-3.5 h-3.5" /> {t("card_read")}
        </Link>
      </div>
    </div>
  );
};

export default StoryCard;
